import {fetch} from "utils/dataAccess";
import normalizeTranslations from "../../actions/translations";

export default async function update(reason, values)  {
    values = normalizeTranslations(values);

    values.email = values.emailTemplate !== '';

    const response = await fetch(`/cancellation_reasons/${reason.id}`, {
        method: "PUT",
        body: JSON.stringify(values),
    });

    return await response.json();
}
